export default __webpack_public_path__ + "static/media/robusta-3.c347fb6b.jpg";